"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var React = _interopRequireWildcard(require("react"));
var _reactUid = require("react-uid");
var _controlContainer = require("./controlContainer");
var _rawInput = require("./rawControls/rawInput");
var _iconTypes = require("../../styles/icon-types");
var _HelperText = require("./helpers/HelperText");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Input = exports.Input = /*#__PURE__*/React.forwardRef(({
  id,
  accept,
  autoComplete,
  className,
  hasError,
  label,
  maxLength,
  name,
  onChange,
  onKeyDown,
  onBlur,
  placeholder,
  readOnly,
  type,
  value,
  disabled,
  defaultValue,
  required,
  validationErrorId,
  hidden,
  helperText,
  icon,
  iconColor,
  min,
  max
}, ref) => {
  const inputId = (0, _reactUid.useUID)();
  return (0, _jsxRuntime.jsxs)(_controlContainer.ControlContainer, {
    className: className,
    disabled: disabled,
    hasError: hasError,
    label: label,
    required: required,
    inputId: id ?? inputId,
    children: [(0, _jsxRuntime.jsx)(_rawInput.RawInput, {
      id: id ?? inputId,
      accept: accept,
      autoComplete: autoComplete,
      hasError: hasError,
      maxLength: maxLength,
      name: name,
      onChange: onChange,
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      placeholder: placeholder,
      readOnly: readOnly,
      ref: ref,
      type: type,
      value: value,
      disabled: disabled,
      isHidden: hidden,
      defaultValue: defaultValue,
      required: required,
      validationErrorId: helperText ? `${id ?? inputId}-description` : validationErrorId,
      insetIcon: hasError ? _iconTypes.Icons.Error : icon,
      iconColor: iconColor,
      min: min,
      max: max
    }, void 0), helperText && (0, _jsxRuntime.jsx)(_HelperText.HelperText, {
      disabled: disabled,
      hasError: hasError,
      inputId: id ?? inputId,
      children: helperText
    }, void 0)]
  }, void 0);
});
Input.displayName = 'Input';